import React, { useState, useEffect } from "react";
import { Link, Navigate, useParams, useNavigate } from "react-router-dom";
//remember, have to replace data-feather with font awesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import _, { filter } from "lodash";
import { Card, Row, Col, Button, Skeleton, Tabs, Descriptions, Space, Tag, Table, Input, Popconfirm, Drawer, Tooltip, Avatar } from "antd";
import Select from "react-select";
import {
  faFolder,
  faFileInvoice,
  faCreditCard,
  faFileAlt,
  faCalendarAlt,
  faEdit,
  faDollarSign,
  faFileInvoiceDollar,
  faPlus,
  faTrash,
  faBinoculars,
  faWrench,
  faHistory,
  faCalendarCheck,
  faMailBulk,
  faEnvelope,
  faPhone,
  faPhoneAlt,
} from "@fortawesome/free-solid-svg-icons";
import dayjs from "dayjs";
import ModalQuickViewClient from "./ModalQuickViewClient";
import ModalAddJob from "./ModalAddJob";
import ModalEditJob from "./ModalEditJob";
import ModalAddTask from "./ModalAddTask";
import ModalViewTask from "./ModalViewTask";
import ModalAddTimeEntry from "./ModalAddTimeEntry";
import ModalEditTimeEntry from "./ModalEditTimeEntry";
import ModalEditRecurringTask from "./ModalEditRecurringTask";

function ClientDetails(props) {
  const navigate = useNavigate();
  const [client, setClient] = useState(null);
  const [company, setCompany] = useState(null);

  const [jobs, setJobs] = useState([]);
  const [filteredJobs, setFilteredJobs] = useState([]);
  const [tasks, setTasks] = useState([]);
  const [filteredTasks, setFilteredTasks] = useState([]);
  const [timeEntries, setTimeEntries] = useState([]);
  const [filteredTimeEntries, setFilteredTimeEntries] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [filteredInvoices, setFilteredInvoices] = useState([]);
  const [payments, setPayments] = useState([]);
  const [filteredPayments, setFilteredPayments] = useState([]);
  const [recurringTasks, setRecurringTasks] = useState([]);
  const [filteredRecurringTasks, setFilteredRecurringTasks] = useState([]);

  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);

  const [jobSearchTerm, setJobSearchTerm] = useState("");
  const [taskSearchTerm, setTaskSearchTerm] = useState("");
  const [timeEntrySearchTerm, setTimeEntrySearchTerm] = useState("");
  const [invoiceSearchTerm, setInvoiceSearchTerm] = useState("");
  const [paymentSearchTerm, setPaymentSearchTerm] = useState("");
  const [recurringTaskSearchTerm, setRecurringTaskSearchTerm] = useState("");

  const [selectedTabKey, setSelectedTabKey] = useState("1");

  const [quickViewProps, setQuickViewProps] = useState({ open: false, client_id: null, force_editing: true, refresh: false });
  const { client_tag } = useParams();

  const [contactDrawerOpen, setContactDrawerOpen] = useState(false);

  const GetClient = async () => {
    let request = await props.AxiosRequest("/api/clients/get", { tag: client_tag });
    setClient(request.data.client);
    if (!quickViewProps.client_id) setQuickViewProps({ ...quickViewProps, client_id: request.data.client.id }); //This if is important, otherwise client details page loops, endlessly calling clients/get
  };
  const GetCompany = async () => {
    let request = await props.AxiosRequest("/api/companies/get");
    setCompany(request.data.company);
  };
  const GetJobs = async () => {
    let request = await props.AxiosRequest("/api/jobs/get", { client_id: client?.id });
    setJobs(
      request.data.jobs.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const DeleteJob = async (id) => {
    await props.AxiosRequest("/api/jobs/delete", { id });
    GetJobs();
  };
  const GetTasks = async () => {
    let request = await props.AxiosRequest("/api/tasks/get/by-client", { client_id: client?.id, cid: client?.id });
    setTasks(
      request.data.tasks.map((m) => {
        return { ...m, value: m.id, label: m.description };
      }),
    );
  };
  const DeleteTask = async (id) => {
    await props.AxiosRequest("/api/tasks/delete", { id });
    GetTasks();
  };
  const GetTimeEntries = async () => {
    let request = await props.AxiosRequest("/api/time-entries/get", { clients_xref: client?.id, cid: client?.id });
    setTimeEntries(
      request.data.time_entries.map((m) => {
        return { ...m, value: m.id, label: m.name };
      }),
    );
  };
  const DeleteTimeEntry = async (id) => {
    await props.AxiosRequest("/api/time-entries/delete", { id });
    GetTimeEntries();
  };
  const GetInvoices = async () => {
    let request = await props.AxiosRequest("/api/invoices/get/by-client", { client_id: client?.id, cid: client?.id });
    setInvoices(request.data.invoices);
  };
  const GetPayments = async () => {
    let request = await props.AxiosRequest("/api/payments/get/by-client", { client_id: client?.id, cid: client?.id });
    setPayments(request.data.payments);
  };
  const GetRecurringTasks = async () => {
    let request = await props.AxiosRequest("/api/recurring-tasks/get/by-client", { client_id: client?.id, cid: client?.id });
    setRecurringTasks(request.data.recurring_tasks);
  };
  const AddInvoiceAndGoToInvoice = async () => {
    let request = await props.AxiosRequest("/api/invoices/insert", { clients_xref: client.id });
    navigate("/invoicing/" + request.data.tag);
  };
  const TriggerRecurringTask = async (recurring_task_id) => {
    await props.AxiosRequest("/api/recurring-tasks/trigger", { id: recurring_task_id });
    GetRecurringTasks();
    GetTasks();
  };
  const DeleteRecurringTask = async (id) => {
    await props.AxiosRequest("/api/recurring-tasks/delete", { id });
    GetRecurringTasks();
    GetTasks();
  };
  const FilterJobs = async () => {
    if (!jobSearchTerm) return setFilteredJobs(jobs);
    let filtered_list = jobs.filter((f) =>
      _.toLower(f.name).indexOf(_.toLower(jobSearchTerm)) > -1 ||
      _.toLower(f.comments).indexOf(_.toLower(jobSearchTerm)) > -1 ||
      _.toLower(f.job_status_name).indexOf(_.toLower(jobSearchTerm)) > -1 ||
      _.toLower(f.item_name).indexOf(_.toLower(jobSearchTerm)) > -1 ||
      _.toLower(f.promised_by).indexOf(_.toLower(jobSearchTerm)) > -1 ||
      _.toLower(props.MakeDateTimeReadable(f.promised_by)).indexOf(_.toLower(jobSearchTerm)) > -1
        ? true
        : false,
    );
    setFilteredJobs(filtered_list);
  };
  const FilterTasks = async () => {
    if (!taskSearchTerm && !selectedJob) return setFilteredTasks(tasks);
    let filtered_list = tasks;
    if (taskSearchTerm)
      filtered_list = tasks.filter((f) =>
        _.toLower(f.description).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.name).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.comments).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.job_status_name).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.item_name).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.promised_by).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(f.job_name).indexOf(_.toLower(taskSearchTerm)) > -1 ||
        _.toLower(props.MakeDateTimeReadable(f.promised_by)).indexOf(_.toLower(taskSearchTerm)) > -1
          ? true
          : false,
      );
    if (selectedJob) filtered_list = filtered_list.filter((f) => f.jobs_xref === selectedJob.id);
    setFilteredTasks(filtered_list);
  };
  const FilterTimeEntries = async () => {
    if (!timeEntrySearchTerm && !selectedJob && !selectedTask) return setFilteredTimeEntries(timeEntries);
    let filtered_list = timeEntries.filter((f) =>
      _.toLower(f.comments).indexOf(_.toLower(timeEntrySearchTerm)) > -1 ||
      _.toLower(f.task_status_name).indexOf(_.toLower(timeEntrySearchTerm)) > -1 ||
      _.toLower(f.item_name).indexOf(_.toLower(timeEntrySearchTerm)) > -1 ||
      _.toLower(f.due_at).indexOf(_.toLower(timeEntrySearchTerm)) > -1 ||
      _.toLower(f.time_by).indexOf(_.toLower(timeEntrySearchTerm)) > -1 ||
      _.toLower(props.MakeDateTimeReadable(f.promised_by)).indexOf(_.toLower(timeEntrySearchTerm)) > -1
        ? true
        : false,
    );
    if (selectedJob) filtered_list = filtered_list.filter((f) => f.jobs_xref === selectedJob.id);
    if (selectedTask) filtered_list = filtered_list.filter((f) => f.tasks_xref === selectedTask.id);
    setFilteredTimeEntries(filtered_list);
  };
  const FilterRecurringTasks = async () => {
    if (!recurringTaskSearchTerm) return setFilteredRecurringTasks(recurringTasks);
    let filtered_list = recurringTasks.filter((f) =>
      _.toLower(f.description).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.comments).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.task_status_name).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.item_name).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.next_scheduled_at).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.due_at).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(f.time_by).indexOf(_.toLower(recurringTaskSearchTerm)) > -1 ||
      _.toLower(props.MakeDateTimeReadable(f.promised_by)).indexOf(_.toLower(recurringTaskSearchTerm)) > -1
        ? true
        : false,
    );
    if (selectedJob) filtered_list = filtered_list.filter((f) => f.jobs_xref === selectedJob.id);
    if (selectedTask) filtered_list = filtered_list.filter((f) => f.tasks_xref === selectedTask.id);
    setFilteredRecurringTasks(filtered_list);
  };
  const FilterInvoices = async () => {
    if (!invoiceSearchTerm) return setFilteredInvoices(invoices);
    let filtered_list = invoices.filter((f) =>
      _.toLower(f.name).indexOf(_.toLower(invoiceSearchTerm)) > -1 ||
      _.toLower(f.transaction_id).indexOf(_.toLower(invoiceSearchTerm)) > -1 ||
      _.toLower(f.invoiced_at).indexOf(_.toLower(invoiceSearchTerm)) > -1 ||
      _.toLower(f.due_at).indexOf(_.toLower(invoiceSearchTerm)) > -1 ||
      _.toLower(f.exported_at).indexOf(_.toLower(invoiceSearchTerm)) > -1 ||
      _.toLower(f.amount).indexOf(_.toLower(invoiceSearchTerm)) > -1
        ? true
        : false,
    );
    if (selectedJob) filtered_list = filtered_list.filter((f) => f.jobs_xref === selectedJob.id);
    if (selectedTask) filtered_list = filtered_list.filter((f) => f.tasks_xref === selectedTask.id);
    setFilteredInvoices(filtered_list);
  };
  const FilterPayments = async () => {
    if (!paymentSearchTerm) return setFilteredPayments(payments);
    let filtered_list = payments.filter((f) =>
      _.toLower(f.id).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.transaction_id).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.first_name).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.last_name).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.status).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.amount).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.memo).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.clients_xref).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.companies_xref).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.received_at).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.card_last_4).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.type).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.exported_at).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.export_batches_xref).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.fundings_xref).indexOf(_.toLower(paymentSearchTerm)) > -1 ||
      _.toLower(f.merchant_funding_id).indexOf(_.toLower(paymentSearchTerm)) > -1
        ? true
        : false,
    );
    if (selectedJob) filtered_list = filtered_list.filter((f) => f.jobs_xref === selectedJob.id);
    if (selectedTask) filtered_list = filtered_list.filter((f) => f.tasks_xref === selectedTask.id);
    setFilteredPayments(filtered_list);
  };

  const [addJobProps, setAddJobProps] = useState({
    open: false,
    client_id: null,
    refresh: false,
  });
  const [editJobProps, setEditJobProps] = useState({
    open: false,
    client_id: null,
    job_id: null,
    refresh: false,
  });
  const [addTaskProps, setAddTaskProps] = useState({
    open: false,
    job_id: null,
    client_id: null,
    refresh: false,
  });
  const [viewTaskProps, setViewTaskProps] = useState({
    open: false,
    job_id: null,
    client_id: null,
    refresh: false,
  });
  const [editRecurringTaskProps, setEditRecurringTaskProps] = useState({
    open: false,
    task_id: null,
    refresh: false,
  });
  const [addTimeEntryProps, setAddTimeEntryProps] = useState({
    open: false,
    job_id: null,
    task_id: null,
    client_id: null,
    refresh: false,
  });
  const [editTimeEntryProps, setEditTimeEntryProps] = useState({
    open: false,
    job_id: null,
    task_id: null,
    time_id: null,
    client_id: null,
    refresh: false,
  });

  useEffect(() => {
    if (client_tag && !client) {
      GetClient();
    }
  }, [client_tag, client?.id]);

  useEffect(() => {
    GetCompany();
  }, []);

  useEffect(() => {
    if (client?.id) {
      GetJobs();
      GetTasks();
      GetTimeEntries();
      GetInvoices();
      GetPayments();
      GetRecurringTasks();
    }
  }, [client?.id, selectedTabKey]);

  useEffect(() => {
    if (addJobProps.refresh || editJobProps.refresh) {
      setAddJobProps({ ...addJobProps, refresh: false });
      setEditJobProps({ ...editJobProps, refresh: false });
      GetJobs();
    }
  }, [addJobProps?.refresh, editJobProps?.refresh]);

  useEffect(() => {
    if (addTaskProps.refresh || viewTaskProps.refresh) {
      setAddTaskProps({ ...addTaskProps, refresh: false });
      setViewTaskProps({ ...viewTaskProps, refresh: false });
      GetTasks();
      GetRecurringTasks();
    }
  }, [addTaskProps?.refresh, viewTaskProps?.refresh]);

  useEffect(() => {
    if (editRecurringTaskProps.refresh) {
      setEditRecurringTaskProps({ ...editRecurringTaskProps, refresh: false });
      GetRecurringTasks();
    }
  }, [editRecurringTaskProps?.refresh]);

  useEffect(() => {
    if (addTimeEntryProps.refresh || editTimeEntryProps.refresh) {
      setAddTimeEntryProps({ ...addTimeEntryProps, refresh: false });
      setEditTimeEntryProps({ ...editTimeEntryProps, refresh: false });
      GetTimeEntries();
    }
  }, [addTimeEntryProps?.refresh, editTimeEntryProps?.refresh]);

  useEffect(() => {
    if (quickViewProps.refresh) {
      setQuickViewProps({ ...quickViewProps, refresh: false });
      GetClient();
    }
  }, [quickViewProps?.refresh]);

  useEffect(() => {
    FilterJobs();
  }, [jobSearchTerm, jobs]);

  useEffect(() => {
    FilterTasks();
  }, [taskSearchTerm, tasks, selectedJob]);

  useEffect(() => {
    FilterTimeEntries();
  }, [timeEntrySearchTerm, timeEntries, selectedJob, selectedTask]);

  useEffect(() => {
    FilterRecurringTasks();
  }, [recurringTasks, recurringTaskSearchTerm]);
  useEffect(() => {
    FilterInvoices();
  }, [invoices, invoiceSearchTerm]);
  useEffect(() => {
    FilterPayments();
  }, [payments, paymentSearchTerm]);
  useEffect(() => {
    setAddTimeEntryProps({ ...addTimeEntryProps, client_id: client?.id });
  }, [client?.id]);
  useEffect(() => {
    setAddTimeEntryProps({ ...addTimeEntryProps, job_id: selectedJob?.id });
  }, [selectedJob?.id]);
  useEffect(() => {
    setAddTimeEntryProps({ ...addTimeEntryProps, task_id: selectedTask?.id });
  }, [selectedTask?.id]);

  useEffect(() => {
    let found_job = jobs.find((f) => f.id === addJobProps?.new_job_id);
    if (found_job) {
      setAddJobProps({ ...addJobProps, new_job_id: null });
      setSelectedJob(found_job);
      setJobSearchTerm(null);
      setSelectedTabKey("2");
    }
  }, [addJobProps?.new_job_id, jobs]);
  useEffect(() => {
    let found_task = tasks.find((f) => f.id === addTaskProps?.new_task_id);
    if (found_task) {
      setAddTaskProps({ ...addTaskProps, new_task_id: null });
      setSelectedTask(found_task);
      setTaskSearchTerm(null);
      setSelectedTabKey("3");
    }
  }, [addTaskProps?.new_task_id, tasks]);

  const job_columns = [
    {
      title: "Job Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (text) => <Input.TextArea value={text}></Input.TextArea>,
      // sorter: (a, b) => a.comments - b.comments,
    },
    {
      title: "Status",
      dataIndex: "job_status_name",
      key: "job_status_name",
      render: (text) => <Tag>{text}</Tag>,
      sorter: (a, b) => (a.job_status_name.toUpperCase() < b.job_status_name.toUpperCase() ? -1 : a.job_status_name.toUpperCase() > b.job_status_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
      sorter: (a, b) => (a.item_name.toUpperCase() < b.item_name.toUpperCase() ? -1 : a.item_name.toUpperCase() > b.item_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Due Date",
      dataIndex: "promised_by",
      key: "promised_by",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) =>
        dayjs(a.promised_by).format("YYYYMMDDHHmmss") < dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? -1
          : dayjs(a.promised_by).format("YYYYMMDDHHmmss") > dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? 1
          : 0,
      defaultSortOrder: "descend",
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "right",
      key: "id",
      render: (value, object) => {
        return (
          <Space>
            <Button
              size="small"
              onClick={() => {
                setSelectedJob(object);
                setTaskSearchTerm(null);
                setSelectedTabKey("2");
              }}
            >
              <FontAwesomeIcon icon={faBinoculars} className="mr-1" />
              View Tasks
            </Button>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditJobProps({ ...editJobProps, job_id: object.id, client_id: client.id, open: true });
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="mr-1" />
              Edit
            </Button>
            <Popconfirm
              title="Are you sure?"
              description={'Are you sure you want to delete the job "' + object.name + '"?'}
              onConfirm={() => {
                DeleteJob(object.id);
              }}
            >
              <Button size="small" danger>
                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                Delete
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const task_columns = [
    {
      title: "Task Name",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => (a.description.toUpperCase() < b.description.toUpperCase() ? -1 : a.description.toUpperCase() > b.description.toUpperCase() ? 1 : 0),
    },
    {
      title: "Job",
      dataIndex: "job_name",
      key: "job_name",
      sorter: (a, b) => (a.job_name.toUpperCase() < b.job_name.toUpperCase() ? -1 : a.job_name.toUpperCase() > b.job_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Assigned To",
      dataIndex: "owned_by",
      key: "owned_by",
      render: (text, row) => {
        if (text === "null") return "";
        if (row.owned_by_image_link !== "dui2.png")
          return (
            <Tooltip title={text}>
              <Avatar
                style={{
                  backgroundColor: "#00a2ae",
                  verticalAlign: "middle",
                }}
                size="large"
                gap={1}
                src={<img src={"https://firmtamer-public-bucket.s3.amazonaws.com/" + row.owned_by_image_link} alt="avatar" />}
              />
            </Tooltip>
          );
        return (
          <Tooltip title={text}>
            <Avatar
              style={{
                backgroundColor: "#00a2ae",
                verticalAlign: "middle",
              }}
              size="large"
              gap={4}
            >
              {_.words(text)
                .map((m) => m[0])
                .join(" ")}
            </Avatar>
          </Tooltip>
        );
      },
      sorter: (a, b) => (a.owned_by.toUpperCase() < b.owned_by.toUpperCase() ? -1 : a.owned_by.toUpperCase() > b.owned_by.toUpperCase() ? 1 : 0),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (text) => <Input.TextArea value={text}></Input.TextArea>,
    },
    {
      title: "Status",
      dataIndex: "task_status_name",
      key: "task_status_name",
      render: (text) => <Tag>{text}</Tag>,
      sorter: (a, b) => (a.task_status_name.toUpperCase() < b.task_status_name.toUpperCase() ? -1 : a.task_status_name.toUpperCase() > b.task_status_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
      sorter: (a, b) => (a.item_name.toUpperCase() < b.item_name.toUpperCase() ? -1 : a.item_name.toUpperCase() > b.item_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Due Date",
      dataIndex: "due_at",
      key: "due_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) =>
        dayjs(a.due_at).format("YYYYMMDDHHmmss") < dayjs(b.due_at).format("YYYYMMDDHHmmss") ? -1 : dayjs(a.due_at).format("YYYYMMDDHHmmss") > dayjs(b.due_at).format("YYYYMMDDHHmmss") ? 1 : 0,

      defaultSortOrder: "descend",
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (value, object) => {
        return (
          <Space>
            <Button
              size="small"
              onClick={() => {
                setSelectedTask(object);
                setTaskSearchTerm(null);
                setSelectedTabKey("3");
              }}
            >
              <FontAwesomeIcon icon={faBinoculars} className="mr-1" />
              View Time Entries
            </Button>
            <Button
              size="small"
              type="primary"
              abs={object.id}
              onClick={() => {
                setViewTaskProps({ ...viewTaskProps, task_id: object.id, open: true, editing: true });
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="mr-1" />
              Edit
            </Button>
            <Popconfirm
              title="Are you sure?"
              description={'Are you sure you want to delete the task "' + object.description + '"?'}
              onConfirm={() => {
                DeleteTask(object.id);
              }}
            >
              <Button size="small" danger>
                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                Delete
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const time_columns = [
    {
      title: "User",
      dataIndex: "users_name",
      key: "users_name",
      sorter: (a, b) => (a.users_name.toUpperCase() < b.users_name.toUpperCase() ? -1 : a.users_name.toUpperCase() > b.users_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Item",
      dataIndex: "items_name",
      key: "items_name",
    },
    {
      title: "Date of Work",
      dataIndex: "time_at",
      key: "time_at",
      render: (text) => props.MakeDateTimeReadable(text),
      defaultSortOrder: "descend",
      sorter: (a, b) => (a.time_at < b.time_at ? -1 : a.time_at > b.time_at ? 1 : 0),
    },
    {
      title: "Hours",
      dataIndex: "hours",
      key: "hours",
      render: (value) => props.FormatNumberTwoDecimals(value),
      // sorter: (a, b) => (a.item_name.toUpperCase() < b.item_name.toUpperCase() ? -1 : a.item_name.toUpperCase() > b.item_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      width: "25vw",
      render: (text) => <Input.TextArea value={text ? text : ""} rows={1} style={{ resize: "both" }}></Input.TextArea>,
      sorter: (a, b) => {},
    },
    {
      title: "Task Status",
      dataIndex: "task_statuses_name",
      key: "task_statuses_name",
    },
    {
      title: "Bill Rate",
      dataIndex: "bill_rate",
      key: "bill_rate",
      render: (text) => props.FormatNumberToCurrency(text),
    },
    {
      title: "Billing Status",
      dataIndex: "billing_statuses_name",
      key: "billing_statuses_name",
    },
    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (value, object) => {
        return (
          <Space>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditTimeEntryProps({ ...editTimeEntryProps, time_id: object.id, client_id: client.id, job_id: object.jobs_xref, task_id: object.tasks_xref, open: true, editing: true });
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="mr-1" />
              Edit
            </Button>
            <Popconfirm
              title="Are you sure?"
              description={"Are you sure you want to delete this time entry?"}
              onConfirm={() => {
                DeleteTimeEntry(object.id);
              }}
            >
              <Button
                size="small"
                danger
                onClick={() => {
                  // setDeleteModalOpen(true);
                  // setSelectedBillingStatusCategory(billingStatusCategories.find((f) => f.id === text));
                }}
              >
                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                Delete
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];
  const invoice_columns = [
    {
      title: "Invoice Number",
      dataIndex: "name",
      key: "name",
      render: (value, object) => (
        <Link to={"/invoicing/" + object.tag}>
          <Tag>#{value}</Tag>
        </Link>
      ),
      sorter: (a, b) => (a.name.toUpperCase() < b.name.toUpperCase() ? -1 : a.name.toUpperCase() > b.name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Invoice Total",
      dataIndex: "total",
      key: "total",
      align: "right",
      render: (text, row) => props.FormatNumberToCurrency(text),
      sorter: (a, b) => (a.total < b.total ? -1 : 1),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (text == 1 ? <Tag color="#108ee9">Proposed</Tag> : <Tag color="#87d068">Finalized</Tag>),
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Invoiced At",
      dataIndex: "invoiced_at",
      key: "invoiced_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.invoiced_at.toUpperCase() < b.invoiced_at.toUpperCase() ? -1 : a.invoiced_at.toUpperCase() > b.invoiced_at.toUpperCase() ? 1 : 0),
      defaultSortOrder: "descend",
    },
    {
      title: "Due At",
      dataIndex: "due_at",
      key: "due_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.due_at.toUpperCase() < b.due_at.toUpperCase() ? -1 : a.due_at.toUpperCase() > b.due_at.toUpperCase() ? 1 : 0),
    },
    {
      title: "Exported At",
      dataIndex: "exported_at",
      key: "exported_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.exported_at.toUpperCase() < b.exported_at.toUpperCase() ? -1 : a.exported_at.toUpperCase() > b.exported_at.toUpperCase() ? 1 : 0),
    },

    {
      title: "Actions",
      dataIndex: "id",
      key: "id",
      align: "right",
      render: (value, object) => (
        <Space>
          <Link to={"/invoicing/" + object.tag}>
            <Button size="small" type="primary" icon={<FontAwesomeIcon icon={faEdit} />}>
              Edit Invoice
            </Button>
          </Link>
          <Link to={"/invoice-preview/" + object.tag}>
            <Button size="small" icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}>
              Print/Email Invoice
            </Button>
          </Link>
          <Link to={"/portal/payments-direct/c/" + client.tag + "/i/" + object.tag} target="_blank">
            <Button size="small" icon={<FontAwesomeIcon icon={faDollarSign} />}>
              Take Payment For Invoice
            </Button>
          </Link>
        </Space>
      ),
    },
  ];
  const payments_columns = [
    {
      title: "Payee",
      dataIndex: "customer_name",
      key: "customer_name",
      sorter: (a, b) => (a.customer_name.toUpperCase() < b.customer_name.toUpperCase() ? -1 : a.customer_name.toUpperCase() > b.customer_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      align: "right",
      render: (value) => props.FormatNumberToCurrency(value),
      sorter: (a, b) => (a.amount.toUpperCase() < b.amount.toUpperCase() ? -1 : a.amount.toUpperCase() > b.amount.toUpperCase() ? 1 : 0),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text, object) => {
        if (!text) {
          if (dayjs(object.received_at).diff(dayjs(), "hours") < 8) {
            return <Tag color="#F1B17A"> No Status Yet</Tag>;
          }
          return <Tag color="#CA494C"> Failed Payment </Tag>;
        }
        return <Tag color={text == "finalized" || text == "complete" || text == "settled" || text == "exported" ? "#87d068" : "#108ee9"}>{_.startCase(text)}</Tag>;
      },
      sorter: (a, b) => (a.status.toUpperCase() < b.status.toUpperCase() ? -1 : a.status.toUpperCase() > b.status.toUpperCase() ? 1 : 0),
    },
    {
      title: "Date Received",
      dataIndex: "received_at",
      key: "received_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) => (a.received_at.toUpperCase() < b.received_at.toUpperCase() ? -1 : a.received_at.toUpperCase() > b.received_at.toUpperCase() ? 1 : 0),
      defaultSortOrder: "asc",
    },
    {
      title: "Memo",
      dataIndex: "memo",
      key: "memo",
      render: (text) => <Input.TextArea value={text} />,
      sorter: (a, b) => (a.memo.toUpperCase() < b.memo.toUpperCase() ? -1 : a.memo.toUpperCase() > b.memo.toUpperCase() ? 1 : 0),
    },
    {
      title: "Transaction ID",
      dataIndex: "transaction_id",
      key: "transaction_id",
      render: (value) => <Input readOnly value={value} />,
      sorter: (a, b) => (a.transaction_id.toUpperCase() > b.transaction_id.toUpperCase() ? 1 : -1),
    },
    // {
    //   title: "Payment Type",
    //   dataIndex: "card_type",
    //   key: "card_type",
    //   render: (text) => {
    //     let icon;
    //     if(text==='amex') icon=
    //   },
    //   sorter: (a, b) => (a.memo.toUpperCase() < b.memo.toUpperCase() ? -1 : a.memo.toUpperCase() > b.memo.toUpperCase() ? 1 : 0),
    // },
    {
      title: "Card Last 4",
      dataIndex: "card_last_4",
      key: "card_last_4",
      align: "right",
      render: (text) => (text ? "****" + text : "Not Yet Updated"),
      sorter: (a, b) => (a.card_last_4.toUpperCase() < b.card_last_4.toUpperCase() ? -1 : a.card_last_4.toUpperCase() > b.card_last_4.toUpperCase() ? 1 : 0),
    },

    // {
    //   title: "Actions",
    //   dataIndex: "id",
    //   key: "id",
    //   align: "right",
    //   render: (value, object) => (
    //     <Space>
    //       <Link to={"/invoicing/" + object.tag}>
    //         <Button size="small" type="primary" icon={<FontAwesomeIcon icon={faEdit} />}>
    //           Edit Invoice
    //         </Button>
    //       </Link>
    //       <Link to={"/invoice-preview/" + object.tag}>
    //         <Button size="small" icon={<FontAwesomeIcon icon={faFileInvoiceDollar} />}>
    //           Print/Email Invoice
    //         </Button>
    //       </Link>
    //       <Link to={"/portal/payments-direct/c/" + client.tag + "/i/" + object.tag}>
    //         <Button size="small" icon={<FontAwesomeIcon icon={faDollarSign} />}>
    //           Take Payment For Invoice
    //         </Button>
    //       </Link>
    //     </Space>
    //   ),
    // },
  ];
  const recurring_tasks_columns = [
    {
      title: "Name",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => (a.description.toUpperCase() < b.description.toUpperCase() ? -1 : a.description.toUpperCase() > b.description.toUpperCase() ? 1 : 0),
    },
    {
      title: "Job",
      dataIndex: "job_name",
      key: "job_name",
      sorter: (a, b) => (a.job_name.toUpperCase() < b.job_name.toUpperCase() ? -1 : a.job_name.toUpperCase() > b.job_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Comments",
      dataIndex: "comments",
      key: "comments",
      render: (text) => <Input.TextArea value={text}></Input.TextArea>,
    },
    {
      title: "Item",
      dataIndex: "item_name",
      key: "item_name",
      sorter: (a, b) => (a.item_name.toUpperCase() < b.item_name.toUpperCase() ? -1 : a.item_name.toUpperCase() > b.item_name.toUpperCase() ? 1 : 0),
    },
    {
      title: "Next Scheduled Date",
      dataIndex: "next_scheduled_at",
      key: "next_scheduled_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) =>
        dayjs(a.promised_by).format("YYYYMMDDHHmmss") < dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? -1
          : dayjs(a.promised_by).format("YYYYMMDDHHmmss") > dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? 1
          : 0,
      defaultSortOrder: "descend",
    },
    {
      title: "Next Due Date",
      dataIndex: "due_at",
      key: "due_at",
      render: (text) => props.MakeDateTimeReadable(text),
      sorter: (a, b) =>
        dayjs(a.promised_by).format("YYYYMMDDHHmmss") < dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? -1
          : dayjs(a.promised_by).format("YYYYMMDDHHmmss") > dayjs(b.promised_by).format("YYYYMMDDHHmmss")
          ? 1
          : 0,
      defaultSortOrder: "descend",
    },
    {
      title: "Frequency",
      dataIndex: "frequency",
      key: "frequency",
      render: (text) => _.startCase(text),
      sorter: (a, b) => (a < b ? -1 : a > b ? 1 : 0),
      defaultSortOrder: "descend",
    },
    {
      title: "Actions",
      align: "right",
      dataIndex: "id",
      key: "id",
      render: (value, object) => {
        return (
          <Space>
            <Button
              size="small"
              onClick={() => {
                TriggerRecurringTask(value);
              }}
            >
              <FontAwesomeIcon icon={faCalendarCheck} className="mr-1" />
              Create Upcoming Task Now
            </Button>
            <Button
              size="small"
              type="primary"
              onClick={() => {
                setEditRecurringTaskProps({ ...editRecurringTaskProps, task_id: object.id, client_id: client.id, open: true, editing: true, recurring: true });
              }}
            >
              <FontAwesomeIcon icon={faEdit} className="mr-1" />
              Edit
            </Button>
            <Popconfirm
              title="Are you sure?"
              description={'Are you sure you want to delete the task "' + object.description + '"?'}
              onConfirm={() => {
                DeleteRecurringTask(object.id);
              }}
            >
              <Button size="small" danger>
                <FontAwesomeIcon icon={faTrash} className="mr-1" />
                Delete
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  const tabs = [
    {
      key: "1",
      label: (
        <>
          <FontAwesomeIcon icon={faFolder} className="mx-2" />
          Jobs
        </>
      ),
      children: (
        <>
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={18}>
              <Button
                type="primary"
                onClick={() => {
                  setAddJobProps({ ...addJobProps, open: true, client_id: client.id });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add A New Job
              </Button>
            </Col>
            <Col span={6}>
              <Input
                value={jobSearchTerm}
                onChange={(e) => {
                  setJobSearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={job_columns} dataSource={filteredJobs}></Table>
        </>
      ),
    },
    {
      key: "2",
      label: (
        <>
          <FontAwesomeIcon icon={faFileAlt} className="mx-2" />
          Tasks
        </>
      ),
      children: (
        <>
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={14}>
              <Button
                type="primary"
                onClick={() => {
                  setAddTaskProps({ ...addTaskProps, open: true, client_id: client.id, job_id: selectedJob?.id || null, recurring: false });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add A New Task
              </Button>
            </Col>
            <Col span={4}>
              <Select
                value={selectedJob}
                options={props.MakeJobOptions(jobs)}
                isClearable
                menuShouldScrollIntoView={true}
                onChange={(e) => {
                  setSelectedJob(e);
                }}
                placeholder="Filter Tasks By Job..."
              />
            </Col>
            <Col span={6}>
              <Input
                value={taskSearchTerm}
                onChange={(e) => {
                  setTaskSearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={task_columns} dataSource={filteredTasks}></Table>
        </>
      ),
    },
    {
      key: "3",
      label: (
        <>
          <FontAwesomeIcon icon={faCalendarAlt} className="mx-2" />
          Time Entries
        </>
      ),
      children: (
        <>
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={10}>
              <Button
                type="primary"
                onClick={() => {
                  setAddTimeEntryProps({ ...addTimeEntryProps, open: true, client_id: client.id, job_id: selectedJob?.id || null, task_id: selectedTask?.id || null });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add A New Time Entry
              </Button>
            </Col>
            <Col span={4}>
              <Select
                value={selectedJob}
                options={props.MakeJobOptions(jobs)}
                isClearable
                menuShouldScrollIntoView={true}
                onChange={(e) => {
                  setSelectedJob(e);
                  if (selectedTask?.jobs_xref !== e?.value) setSelectedTask(null);
                }}
                placeholder="Filter Time Entries By Job..."
              />
            </Col>
            <Col span={4}>
              <Select
                value={selectedTask}
                options={props.MakeTaskOptions(tasks)}
                isClearable
                menuShouldScrollIntoView={true}
                onChange={(e) => {
                  setSelectedTask(e);
                  if (e) {
                    let found_job = jobs.find((f) => f.id === e?.jobs_xref);
                    setSelectedJob(found_job);
                  }
                }}
                placeholder="Filter Time Entries By Task..."
              />
            </Col>
            <Col span={6}>
              <Input
                value={timeEntrySearchTerm}
                onChange={(e) => {
                  setTimeEntrySearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={time_columns} dataSource={filteredTimeEntries}></Table>
        </>
      ),
    },
    {
      key: "4",
      label: (
        <>
          <FontAwesomeIcon icon={faFileInvoice} className="mx-2" />
          Invoices
        </>
      ),
      children: (
        <>
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={10}>
              <Button
                type="primary"
                onClick={() => {
                  AddInvoiceAndGoToInvoice();
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add A New Invoice
              </Button>
            </Col>
            <Col span={8}></Col>
            <Col span={6}>
              <Input
                value={invoiceSearchTerm}
                onChange={(e) => {
                  setInvoiceSearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={invoice_columns} dataSource={filteredInvoices}></Table>
        </>
      ),
    },
    {
      key: "5",
      label: (
        <>
          <FontAwesomeIcon icon={faCreditCard} className="mx-2" />
          Payments
        </>
      ),
      children: (
        <>
          {/* <Link to={"/portal/payments-client/f/" + company?.tag + "/c/" + client?.tag} target="_blank">
            <Button className="btn btn-secondary m-1 float-end">
              <FontAwesomeIcon icon="dollar-sign" />
            </Button>
          </Link> */}
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={10}>
              <Link to={"/portal/payments-client/f/" + company?.tag + "/c/" + client?.tag} target="_blank">
                <Button type="primary">
                  <FontAwesomeIcon icon={faDollarSign} className="mr-2" />
                  Take A Payment
                </Button>
              </Link>
            </Col>
            <Col span={8}></Col>
            <Col span={6}>
              <Input
                value={paymentSearchTerm}
                onChange={(e) => {
                  setPaymentSearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={payments_columns} dataSource={filteredPayments}></Table>
        </>
      ),
    },
    {
      key: "6",
      label: (
        <>
          <FontAwesomeIcon icon={faHistory} className="mx-2" />
          Recurring Tasks
        </>
      ),
      children: (
        <>
          <Row gutter={[8, 16]} className="mb-2">
            <Col span={10}>
              <Button
                type="primary"
                onClick={() => {
                  setAddTaskProps({ ...addTaskProps, open: true, client_id: client.id, job_id: selectedJob?.id || null, recurring: true });
                }}
              >
                <FontAwesomeIcon icon={faPlus} className="mr-2" />
                Add A New Recurring Task
              </Button>
            </Col>
            <Col span={8}></Col>
            <Col span={6}>
              <Input
                value={recurringTaskSearchTerm}
                onChange={(e) => {
                  setRecurringTaskSearchTerm(e.target.value);
                }}
                placeholder="Search..."
                allowClear
              />
            </Col>
          </Row>
          <Table columns={recurring_tasks_columns} dataSource={filteredRecurringTasks}></Table>
        </>
      ),
    },
  ];

  return (
    <main className="content">
      <div className="container-fluid">
        <Row>
          <Card
            title={client?.name || <Skeleton.Button active />}
            style={{
              width: "100%",
            }}
            extra={
              <Space>
                <Button
                  onClick={() => {
                    setQuickViewProps({ ...quickViewProps, open: true });
                  }}
                >
                  <FontAwesomeIcon icon={faEdit} className="mr-2" /> Edit Client
                </Button>
                <Button
                  onClick={() => {
                    setContactDrawerOpen(true);
                  }}
                >
                  <FontAwesomeIcon icon={faPhoneAlt} className="mr-2" /> Contact Client
                </Button>
              </Space>
            }
          >
            <Row gutter={[16, 8]}>
              <Col span={24}>
                {client ? (
                  <Descriptions title="Client Details">
                    <Descriptions.Item label="Name">
                      <h5 style={{ marginBottom: "0px" }}>{client.name}</h5>
                    </Descriptions.Item>
                    <Descriptions.Item label="Address">{client.address}</Descriptions.Item>
                    <Descriptions.Item label="Home / Office Phone">{client.office_phone}</Descriptions.Item>
                    <Descriptions.Item label="Client Categories">
                      <Space size={[0, 8]} wrap>
                        {client.client_categories.map((m, i) => (
                          <Tag key={"tag-" + i}>{m.name}</Tag>
                        ))}
                      </Space>
                    </Descriptions.Item>
                    <Descriptions.Item label="Additional Details">{client.additional_details}</Descriptions.Item>
                  </Descriptions>
                ) : (
                  <Skeleton active />
                )}
              </Col>
              <Col span={24}>
                <hr />
              </Col>
              <Col span={24}>
                <Tabs
                  activeKey={selectedTabKey}
                  items={tabs}
                  onChange={(activeKey) => {
                    setSelectedTabKey(activeKey);
                  }}
                />
              </Col>
            </Row>
          </Card>
        </Row>
      </div>
      <Drawer
        title="Contacts"
        placement="right"
        onClose={() => {
          setContactDrawerOpen(false);
        }}
        open={contactDrawerOpen}
        width={"35vw"}
      >
        {client?.client_contacts
          .sort((a, b) => a.seq - b.seq)
          .map((client_contact) => {
            return (
              <Card key={client_contact.id} className="mb-2">
                <Row gutter={[16, 8]}>
                  <Col span={24}>
                    <h5>
                      {client_contact.title ? client_contact.title + ": " : null}
                      {client_contact.name}
                    </h5>
                  </Col>

                  <Col span={24}>
                    <label className="col-form-label-sm w-100">Work Phone:</label>
                    <Input readOnly value={client_contact.work_phone} />
                  </Col>
                  <Col span={24}>
                    <label className="col-form-label-sm w-100">Cell Phone:</label>
                    <Input readOnly value={client_contact.cell_phone} />
                  </Col>
                  <Col span={24}>
                    <label className="col-form-label-sm w-100">Email:</label>
                    <Space.Compact className="w-100">
                      <Input readOnly value={client_contact.email} />
                      {client_contact?.email ? (
                        <Link to={"mailto:" + client_contact.email}>
                          <Button type="primary">
                            <FontAwesomeIcon icon={faEnvelope} className="mr-1" />
                            Send Email
                          </Button>
                        </Link>
                      ) : null}
                    </Space.Compact>
                  </Col>
                  <Col span={24}>
                    <label className="col-form-label-sm w-100">Additional Details:</label>
                    <Input.TextArea cols="30" rows="1" style={{ resize: "vertical" }} readOnly value={client_contact.additional_details} />
                  </Col>
                </Row>
              </Card>
            );
          })}
      </Drawer>
      <ModalQuickViewClient {...props} quickViewProps={quickViewProps} setQuickViewProps={setQuickViewProps} />
      <ModalAddJob {...props} addJobProps={addJobProps} setAddJobProps={setAddJobProps} />
      <ModalEditJob {...props} editJobProps={editJobProps} setEditJobProps={setEditJobProps} />
      <ModalAddTask {...props} addTaskProps={addTaskProps} setAddTaskProps={setAddTaskProps} />
      <ModalViewTask {...props} viewTaskProps={viewTaskProps} setViewTaskProps={setViewTaskProps} />
      <ModalEditRecurringTask {...props} editRecurringTaskProps={editRecurringTaskProps} setEditRecurringTaskProps={setEditRecurringTaskProps} />
      <ModalAddTimeEntry {...props} addTimeEntryProps={addTimeEntryProps} setAddTimeEntryProps={setAddTimeEntryProps} />
      <ModalEditTimeEntry {...props} editTimeEntryProps={editTimeEntryProps} setEditTimeEntryProps={setEditTimeEntryProps} />
    </main>
  );
}

export default ClientDetails;
